module.exports = __webpack_public_path__ + "img/form-t-2.ce7c108c.svg";